import { TZDate } from '@date-fns/tz';
import { isDate } from 'date-fns';

export function convertDatePropertiesToTZDate<T extends Record<string, unknown>>(
    record: T,
    timeZone: string,
) {
    return Object.entries(record).reduce(
        (data, [key, value]) => ({
            ...data,
            [key]: isDate(value) ? new TZDate(value, timeZone) : value,
        }),
        {},
    ) as T;
}
